import React, { useEffect, useState } from 'react';
import { Search, X } from 'lucide-react';
import './ClusterList.css';
import Loading from "../components/Loading"

const backend_url = process.env.REACT_APP_BACKEND_URL;

const DeleteCluster = () => {
  const [clusters, setClusters] = useState([]);
  const [loadError, setLoadError] = useState('');
  const [loading, setLoading] = useState(true);
  const [searchName, setSearchName] = useState('');
  const [filterOwner, setFilterOwner] = useState('');
  const [filterState, setFilterState] = useState('');

  useEffect(() => {
    const fetchClusters = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const res = await fetch(`${backend_url}/api/clusters/deleted`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const data = await res.json();
        if (!res.ok) {
          setClusters([]);
          setLoadError(data?.detail || 'Unable to load clusters.');
          return;
        }
        setClusters(Array.isArray(data) ? data : []);
        setLoadError('');
      } catch (err) {
        console.error('Error fetching deleted clusters:', err);
        setLoadError('Unable to load clusters.');
      } finally {
        setLoading(false);
      }
    };

    fetchClusters();
  }, []);

  const owners = [...new Set(clusters.map(c => c.owner).filter(Boolean))];
  const states = [...new Set(clusters.map(c => c.state).filter(Boolean))];

  const filteredClusters = clusters.filter(cluster => {
    const matchesName = !searchName || cluster.name.toLowerCase().includes(searchName.toLowerCase());
    const matchesOwner = !filterOwner || cluster.owner === filterOwner;
    const matchesState = !filterState || cluster.state === filterState;
    return matchesName && matchesOwner && matchesState;
  });

  const hasActiveFilters = searchName || filterOwner || filterState;

  return (
    <div className="cluster-container">
      <h2>Deleted Clusters</h2>

      {!loading && (
        <div className="filter-bar">
          <div className="filter-search">
            <Search size={16} className="filter-search-icon" />
            <input
              type="text"
              placeholder="Search clusters..."
              value={searchName}
              onChange={(e) => setSearchName(e.target.value)}
            />
            {searchName && (
              <X size={14} className="filter-clear-icon" onClick={() => setSearchName('')} />
            )}
          </div>
          <div className="filter-group">
            <select
              className="filter-select"
              value={filterOwner}
              onChange={(e) => setFilterOwner(e.target.value)}
            >
              <option value="">All Owners</option>
              {owners.map(owner => (
                <option key={owner} value={owner}>{owner}</option>
              ))}
            </select>
            <select
              className="filter-select"
              value={filterState}
              onChange={(e) => setFilterState(e.target.value)}
            >
              <option value="">All States</option>
              {states.map(state => (
                <option key={state} value={state}>{state}</option>
              ))}
            </select>
          </div>
          {hasActiveFilters && (
            <button className="filter-reset" onClick={() => { setSearchName(''); setFilterOwner(''); setFilterState(''); }}>
              Clear
            </button>
          )}
          <span className="filter-count">{filteredClusters.length} of {clusters.length}</span>
        </div>
      )}

      {loading ? (
        <Loading type="skeleton" rows={6} height={52} />
      ) : (
        <table className="cluster-table">
          <thead>
            <tr>
              <th>Cluster Name</th>
              <th>Created By</th>
              <th>Created At</th>
              <th>Deleted On</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {filteredClusters.length === 0 ? (
              <tr>
                <td colSpan="5" className="no-results">
                  {loadError || (clusters.length === 0 ? 'No deleted clusters.' : 'No clusters match the current filters.')}
                </td>
              </tr>
            ) : (
              filteredClusters.map((cluster) => (
                <tr key={cluster.id}>
                  <td>{cluster.name}</td>
                  <td>{cluster.owner}</td>
                  <td>{cluster.created_at ? new Date(cluster.created_at).toLocaleString() : '\u2014'}</td>
                  <td>
                    {cluster.last_updated_at
                      ? new Date(cluster.last_updated_at).toLocaleString()
                      : '\u2014'}
                  </td>
                  <td><span className={`status-tag ${cluster.state.toLowerCase().replace(/\s+/g, '-')}`}>{cluster.state}</span></td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default DeleteCluster;
